{ DraggyView }          = require("views/components/draggy")
{ transform, transition } = require("lib/element")

class SlideAnswerView extends Backbone.View
  template: require("templates/components/engine/slide-answer")

  events: ->
    "touchstart #slide-answer-details .content-scroll": "toggleDraggy"
    "touchmove  #slide-answer-details .content-scroll": "toggleDraggy"
    "touchend   #slide-answer-details .content-scroll": "toggleDraggy"

  initialize: ->
    @draggy = new DraggyView
      el: @el
      lock: "x"
      minY: 0
      maxY: @el.offsetHeight
      isParent: false
      allowPropagation: true

    @toggle(false)

    @listenTo @draggy, "drag", @onDrag
    @listenTo @draggy, "drop", @onDrop

  render: (data = {}) ->
    data = _.extend {}, typogr, data

    @el.classList.toggle "has-takeaway", data.answer.takeaway
    @el.innerHTML = @template(data)

    @draggy.getOffset()
    @draggy.options.maxY = @el.offsetHeight

  onDrag: (draggy, isInitial) ->
    transform draggy.el,
      y: draggy.y
      opacity: 1 - (draggy.y / draggy.options.maxY) / 6
      transition: if isInitial then "all 300ms" else "none"

  onDrop: (draggy, isReset) ->
    if not isReset
      draggy.reset()
    else
      transform draggy.el,
        y: draggy.y
        opacity: 1
        transition: "all 300ms"

  toggle: (enabled) ->
    if enabled
      @draggy.unlock()
    else
      @draggy.lock()

    transition @el, "all 300ms #{if enabled then 600 else 0}ms", true

    transform @el,
      y: if enabled then 0 else "100%"

  destroy: ->
    @draggy.undelegateEvents()
    @draggy = null
    @undelegateEvents()

  toggleDraggy: (e) ->
    if e.currentTarget.scrollHeight > e.currentTarget.offsetHeight
      e.stopImmediatePropagation()
    return true


module.exports = SlideAnswerView
